<div class="admin-page sync-page" [formGroup]="form">
    <section class="admin-panel">
        <header class="admin-panel-h">
            <h3>Sincronização</h3>
            <span class="admin-hint">Importa dados do produtor a partir da integração</span>
        </header>

        <div class="admin-panel-b">
            <div class="admin-kv meta">
                <span class="k">Produtor</span>
                <span class="v" [title]="entity?.name || ''">{{ entity?.name || '—' }}</span>
                <span class="k">Código</span>
                <span class="v code">{{ producerCode || '—' }}</span>
            </div>

            <p class="intro">
                Informe uma data só se quiser sincronizar alterações a partir dela. Sem data, busca o histórico
                completo disponível.
            </p>

            <div class="fields">
                <mat-form-field appearance="outline" class="field field-date">
                    <mat-label>Sincronizar a partir de</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="syncDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker startView="year" [startAt]="startDate"></mat-datepicker>
                    <mat-hint>Deixe em branco para sincronização completa</mat-hint>
                </mat-form-field>
            </div>

            <div class="admin-actions bar">
                <button
                    type="button"
                    mat-flat-button
                    color="primary"
                    (click)="initSync()"
                    [disabled]="isSyncing || !producerCode"
                >
                    <mat-icon>{{ isSyncing ? 'sync' : 'cloud_download' }}</mat-icon>
                    {{ isSyncing ? 'Sincronizando…' : 'Iniciar sincronização' }}
                </button>
                @if (form.get('syncDate')?.value && !isSyncing) {
                <button type="button" mat-button (click)="clearDate()">Limpar data</button>
                }
            </div>

            @if (syncState !== 'idle') {
            <div class="status-box" [class]="syncState">
                <div class="status-top">
                    @if (isSyncing) {
                    <mat-spinner diameter="20"></mat-spinner>
                    } @else if (syncState === 'success') {
                    <mat-icon class="ok">check_circle</mat-icon>
                    } @else {
                    <mat-icon class="bad">error</mat-icon>
                    }
                    <div class="status-text">
                        <b>{{ statusTitle }}</b>
                        <small>{{ statusMessage }}</small>
                    </div>
                    <span class="admin-pill" [class.ok]="syncState === 'success'" [class.warn]="syncState === 'running'" [class.bad]="syncState === 'error'">
                        {{ statusPill }}
                    </span>
                </div>
                @if (isSyncing) {
                <ol class="steps">
                    <li [class.done]="step >= 1" [class.current]="step === 1">1. Envio da solicitação</li>
                    <li [class.done]="step >= 2" [class.current]="step === 2">2. Processamento na integração</li>
                    <li [class.done]="step >= 3" [class.current]="step === 3">3. Conclusão</li>
                </ol>
                }
            </div>
            }
        </div>
    </section>
</div>
